import api from "../api/axios";

export const getAllExpenses = async (id) => {
  try {
    const response = await api.get(`api/reimbursements/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching expenses:", error);
    throw error;
  }
};
